<template>
  <div class="main-page-div" role="main" aria-label="Execute Test Runs Page">
    <v-container fluid class="redesign-main-page-container">
      <v-card class="main-content-card" elevation="0">
        <!-- <v-card-text> --- IGNORE --->
        <v-row no-gutters align="center" class="mb-3">
          <v-col cols="12" md="6">
            <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Execute Test Runs</h1>
          </v-col>
          <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
            <!-- Search -->
            <div class="custom-search-input-wrapper">
              <div class="custom-search-input-container">
                <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                <input id="Testname-field-search-validationProcess" type="text" placeholder="Test Name"
                  class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                  @click="searchName = ''">
                  mdi-close-circle
                </v-icon>
              </div>
            </div>
            <!-- Refresh Button -->
            <v-tooltip location="top" max-width="200">
              <template #activator="{ props }">
                <v-btn id="button-refresh-validationprocess" v-bind="props" icon
                  class="reportdata-icon-btn reportdata-icon-btn--ghost ml-2" variant="flat" @click="ReFreshGet()"
                  aria-label="Reset filters">
                  <v-icon size="24">mdi-restore</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
            <!-- Add Button -->
            <v-btn id="button-add-validationprocess" color="primary" class="control-btn create-btn" variant="elevated"
              size="large" prepend-icon="mdi-plus-circle" rounded="xl" @click="showPopup()">
              <span class="btn-text">{{ $t("add") }}</span>
              <v-tooltip activator="parent" location="top">
                Add New Question Set
              </v-tooltip>
            </v-btn>

          </v-col>
        </v-row>

        <v-data-table-server :items-per-page="options.itemsPerPage" :items-length="searchTotalTable"
          v-model:options="options" :items="dataTable" :headers="headers" :loading="loadingTable">
          <template v-slot:no-data>
            <div class="text-center py-2">
              <div class="text-h7 text-grey-darken-1 mt-4">{{ "Searching \"" + searchName + "\" was not found" }}
              </div>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.number }}</td>
              <td style="text-align: left">{{ item.name }}</td>
              <td style="text-align: left">
                <!-- Process Status with compact design -->
                <div class="status-container">
                  <v-chip :color="getProcessStatusColor(item)" variant="flat" size="small" class="status-chip">
                    <v-icon start size="14">
                      {{ getProcessStatusIcon(item) }}
                    </v-icon>
                    <span class="status-text">{{ item.result }}</span>
                  </v-chip>
                </div>
              </td>
              <!-- <td style="text-align: left">{{ item.status }}</td> -->
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">{{ item.processingDate }}</td>
              <!-- <td style="text-align: center">
                <v-btn id="button-reprocess-validationprocess" color="orange-lighten-1" variant="flat" size="small"
                  :disabled="item.status === 'Processing'
                    " @click="Reprocess(item)" class="minimal-btn" icon>
                  <v-icon size="22" color="white">mdi-file-sync</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Reprocess
                  </v-tooltip>
                </v-btn>
              </td> -->
              <td style="text-align: center">
                <div class="action-container">
                  <div class="action-group">
                    <!-- Reprocess -->
                    <v-btn id="button-reprocess-validationprocess" variant="text" density="comfortable"
                      @click="Reprocess(item)" class="action-btn download-btn" icon
                      :disabled="item.status === 'Processing'">
                      <v-icon color="#FFA726" size="25">mdi-sync</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Reprocess
                      </v-tooltip>
                    </v-btn>

                    <!-- Edit -->
                    <v-btn id="button-edit-popupedit-validationprocess" variant="text" density="comfortable"
                      @click="showPopup(item.processID)" class="action-btn edit-btn" icon
                      :disabled="item.status === 'Processing'">
                      <img :src="images.edit" alt="Edit" class="manage-image-icon" />
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip>
                    </v-btn>

                    <!-- Download -->
                    <v-btn id="button-download-validationprocess" variant="text" density="comfortable"
                      @click="Download(item.processID, item.name, item.isGroup)" class="action-btn download-btn" icon
                      :disabled="item.status === 'Processing'">
                      <v-icon color="#2ABF56" size="25">mdi-tray-arrow-down</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Download Results
                      </v-tooltip>
                    </v-btn>

                    <!-- Custom Divider -->
                    <div class="action-divider"></div>

                    <!-- Delete -->
                    <v-btn id="button-delete-validationprocess" variant="text" density="comfortable"
                      @click="DeleteProcessPopup(item.processID)" class="action-btn delete-btn" icon
                      :disabled="item.status === 'Processing'">
                      <img :src="images.delete" alt="Delete" class="manage-image-icon" />
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </td>
              <td style="text-align: center; padding: 8px">
                <v-btn id="button-score-validationprocess" icon variant="flat" size="large" class="score-btn"
                  @click="GoToScore(item.processID)" :disabled="item.status !== 'success'">
                  <v-img :src="images.chartImg" alt="Results" class="manage-image-icon"></v-img>
                  <v-tooltip activator="parent" location="top">
                    {{
                      item.status === "success"
                        ? "View Dashboard Score"
                        : "Complete process to view scores"
                    }}
                  </v-tooltip>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:bottom>
            <div class="table-bottom-group">
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div class="d-flex flex-column">
                  <span>Total results {{ searchTotalTable }}</span>
                </div>

                <v-data-table-footer :items-per-page-options="itemsPerPageOptions"
                  v-model:items-per-page="options.itemsPerPage" v-model:page="options.page" :length="pageCount" />
              </div>
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <v-dialog ref="form" v-model="Uploaddialog" persistent max-width="900px" class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header Section -->
        <v-card-title class="dialog-header"
          :class="{ 'dialog-header-edit': processID, 'dialog-header-add': !processID }">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">
                {{
                  processID
                    ? "Edit Validation Process"
                    : "Upload Question Set"
                }}
              </h2>
              <p class="dialog-subtitle">
                {{
                  processID
                    ? "Modify the existing validation configuration"
                    : "Create a new validation test configuration"
                }}
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="closeUploaddialog" class="close-button" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Content Section -->
        <v-card-text class="dialog-content">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row no-gutters>
              <!-- Row 1: Test Name & Select Model -->
              <v-col cols="12" sm="12" md="6">
                <div class="d-flex flex-column w-100 pr-5">
                  <label class="input-label">
                    Test Name <span class="required-asterisk">*</span>
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ "Enter a unique title for this batch of uploaded questions for easy tracking in reports."
                      }}</span>
                    </v-tooltip>
                  </label>

                  <v-text-field id="testname-field-validationprocess" placeholder="Enter Test Name"
                    v-model="Validation.validationName" :rules="[rules.required]" variant="outlined"
                    density="comfortable" color="#a0a0a0" class="modern-field" clearable hide-details="auto" required>
                  </v-text-field>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <div class="d-flex flex-column w-100 pl-md-5">
                  <label class="input-label">
                    Select Model
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ "Select the specific AI model version to be used for all subsequent generative tasks."
                      }}</span>
                    </v-tooltip>
                  </label>

                  <v-autocomplete id="modelname-autocomplete-validationprocess" placeholder="Select Models"
                    :items="DDGPTModel" item-title="name" item-value="modelDisplayID" variant="outlined"
                    density="comfortable" color="#a0a0a0" class="modern-field" clearable hide-details="auto"
                    v-model="Validation.modelId" :rules="[rules.required]" required>
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'modelname-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>

              <!-- Row 2: Question Type & Processing -->
              <v-col cols="12" sm="12" md="6" class="mt-4">
                <div class="d-flex flex-column w-100 pr-5">
                  <label class="input-label">
                    Question Type
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Questions designed to test the model's ability to give a correct answer.</span>
                    </v-tooltip>
                  </label>

                  <v-radio-group v-model="Validation.positive" @change="clearRadio()" class="custom-radio-group mt-2"
                    inline hide-details color="#C32E0E">
                    <v-radio id="positive-radio-validationprocess" label="Positive" :value="true"
                      :disabled="!QuestionType" color="#C32E0E" class="custom-radio">
                    </v-radio>

                    <v-radio id="negative-radio-validationprocess" label="Negative" :value="false"
                      :disabled="!QuestionType" color="#C32E0E" class="custom-radio">
                    </v-radio>
                  </v-radio-group>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="mt-4">
                <div class="d-flex flex-column w-100 pl-md-5">
                  <label class="input-label">
                    Processing
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Specify the ordered sequence of operations or models that the system must execute
                        sequentially
                        to process the input and produce the final result.</span>
                    </v-tooltip>
                  </label>

                  <div class="d-flex align-center gap-3 mt-2">
                    <v-radio-group v-model="Validation.isGroup" @change="ChainRadio()" :disabled="!QuestionType"
                      class="custom-radio-group" inline hide-details color="#C32E0E">
                      <v-radio id="chain-radio-validationprocess" label="Chain" :value="true" color="#C32E0E"
                        class="custom-radio">
                      </v-radio>
                    </v-radio-group>

                    <v-btn v-if="Validation.isGroup" id="downloadtemplate-validationprocess" variant="outlined"
                      size="small" prepend-icon="mdi-tray-arrow-down" @click="chainTemplate()" class="template-btn">
                      {{ $t("Template") }}
                    </v-btn>
                  </div>
                </div>
              </v-col>

              <!-- Row 3: Question Set Name & Upload File -->
              <v-col cols="12" sm="12" md="6" class="mt-4">
                <div class="d-flex flex-column w-100 pr-5">
                  <label class="input-label">
                    Question Set Name
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span v-if="Validation.positive">{{ $t("_InfoQuestionPositiveName") }}</span>
                      <span v-else-if="Validation.isGroup">Question positive name</span>
                      <span v-else>{{ $t("_InfoQuestionNegativeName") }}</span>
                    </v-tooltip>
                  </label>

                  <!-- Positive Questions -->
                  <v-autocomplete v-if="Validation.positive" id="questionsetname-autocomplete-validationprocess"
                    placeholder="Select Positive Question Set" :items="DDGenerateQ" item-title="name"
                    item-value="generateID" variant="outlined" density="comfortable" color="#a0a0a0"
                    class="modern-field" clearable hide-details="auto" v-model="Validation.generateId"
                    :disabled="Validation.entity != null || Validation.isGroup">
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'questionsetname-positive-option-' + index"
                        :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>

                  <!-- Chain Questions -->
                  <v-autocomplete v-else-if="Validation.isGroup" id="chainquestion-autocomplete-validationprocess"
                    placeholder="Select Chain Question" :items="chainQuestionList" item-title="name"
                    item-value="generateID" variant="outlined" density="comfortable" color="#a0a0a0"
                    class="modern-field" clearable hide-details="auto" v-model="Validation.generateId">
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'chainquestion-chain-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>

                  <!-- Negative Questions -->
                  <v-autocomplete v-else id="questionnegativename-autocomplete-validationprocess"
                    placeholder="Select Negative Question Set" :items="DDValidationNegative" variant="outlined"
                    density="comfortable" color="#a0a0a0" class="modern-field" clearable hide-details="auto"
                    v-model="Validation.negativeName" :disabled="Validation.entity != null || Validation.isGroup">
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'questionsnegative-negative-option-' + index" :value="item.raw">
                        <template v-slot:title>
                          <span>{{ item.raw }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="mt-4">
                <div class="d-flex flex-column w-100 pl-md-5">
                  <label class="input-label">
                    Upload File
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Upload an Excel file (.xlsx) containing your questions. Maximum file size: 10 MB.</span>
                    </v-tooltip>
                  </label>

                  <v-card class="upload-card" elevation="0">
                    <v-card-text class="d-flex flex-column align-center justify-center pa-6">
                      <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false"
                        :DisabledBtn="Validation.generateId != null || Validation.negativeName != null"
                        :allowType="['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
                        @filesUploaded="processUpload($event)" class="UploadFile" />
                      <div class="text-caption text-grey-darken-1 mt-2">
                        <v-icon size="16" class="mr-1">mdi-file-excel-outline</v-icon>
                        Support Formats : .xlsx (Max 10 MB)
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>

              <!-- Uploaded Files Display -->
              <v-col cols="12" sm="12" md="12" v-show="Validation.entity != null" class="mt-4">
                <div class="field-container">
                  <v-card v-if="uploadedFiles.length > 0" class="files-card" elevation="2" rounded="lg">
                    <v-virtual-scroll :items="uploadedFiles" :height="Math.min(uploadedFiles.length * 60, 120)"
                      :item-height="60">
                      <template v-slot:default="{ item }">
                        <v-list-item class="file-item px-4 py-2">
                          <template v-slot:prepend>
                            <v-avatar size="36" color="success" class="mr-3">
                              <v-icon color="white" size="18">mdi-file-document</v-icon>
                            </v-avatar>
                          </template>

                          <v-list-item-title class="text-subtitle-2 font-weight-medium">
                            {{ item.name }}
                          </v-list-item-title>

                          <v-list-item-subtitle class="text-caption">
                            {{ item.size }} bytes
                          </v-list-item-subtitle>

                          <template v-slot:append>
                            <v-btn @click.stop="removeFile(item.name)" icon="mdi-close" size="small" variant="text"
                              color="error" class="ml-2" />
                          </template>
                        </v-list-item>
                        <v-divider class="mx-4" v-if="
                          uploadedFiles.indexOf(item) <
                          uploadedFiles.length - 1
                        " />
                      </template>
                    </v-virtual-scroll>
                  </v-card>
                </div>
              </v-col>

              <!-- Calculate Scores Checkbox -->
              <v-col cols="12" sm="12" md="12" class="mt-4">
                <div class="border-section-wrapper">
                  <v-checkbox id="calculatescores-checkbox-validationprocess" v-model="Validation.isScore"
                    color="#C32E0E" hide-details>
                    <template v-slot:label>
                      <div class="checkbox-label-wrapper">
                        <span>{{ $t("calculateScores") }}</span>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>Trigger the scoring mechanism to evaluate the results of the model test against the
                            expected
                            answers.</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>

              <!-- Prompt Textarea -->
              <v-col cols="12" sm="12" md="12" v-show="Validation.isScore" class="mt-4">
                <div class="d-flex flex-column w-100">
                  <label class="input-label">
                    Prompt
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Enter the text used to instruct the generative AI model on the desired output or task to be
                        performed.</span>
                    </v-tooltip>
                  </label>

                  <v-textarea variant="outlined" rows="8" auto-grow counter color="#a0a0a0" class="modern-textarea"
                    v-model="Validation.Prompt" hide-details required>
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions Section -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" color="grey" @click="PrepareCancel" class="dialog-action-btn cancel-btn">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn id="button-save-popup-validationprocess" variant="flat" size="large" @click="Save"
            class="dialog-action-btn" :class="{
              'save-btn-edit': processID,
              'save-btn-add': !processID,
            }">
            <v-img :src="images.newSaveImg" alt="Change Password Dialog" class="image-icon-style"></v-img>
            {{ ProcessID ? $t("edit") : $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import DragDropFile from "@/components/DragDropFile.vue";
import Cookies from "js-cookie";
import ExcelJS from "exceljs";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";
import chartImg from "@/assets/Icons/chart-bold.svg";
import deleteIcon from "@/assets/images/trash-solid.svg";
import newSaveImg from "@/assets/Icons/white-save-floppy.svg";

export default {
  name: "ValidationProcess",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  components: { DragDropFile },
  data: () => ({
    userId: Cookies.get("userId"),
    searchName: "",
    ProcessID: null,
    valid: true,
    checkbox1: false,
    dialog: false,
    Uploaddialog: false,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    isFirst: true,
    loadingTable: true,
    DeleteProcessPopUp: false,
    QuestionType: null,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    DDGPTModel: [],
    DDGenerateQ: [],
    chainQuestionList: [],
    DDValidationNegative: [],
    DDValidationPositive: [],
    uploadedFiles: [],
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      // "Azure Internet",
      // "Azure News",
    ],
    Validation: {
      validationName: null,
      modelId: null,
      positive: true,
      negative: false,
      positiveUploadFlag: true,
      generateId: null,
      positiveName: null,
      negativeName: null,
      isScore: true,
      isGroup: false,
      entity: null,
      Prompt: null,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],

    images: {
      edit: editImg,
      delete: deleteImg,
      chartImg: chartImg,
      newSaveImg: newSaveImg,
    }
  }),
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false },
        { title: "Test Name", align: "left", sortable: true, value: "Name" },
        {
          title: "Process Status",
          align: "left",
          sortable: true,
          value: "ImportedDataCount",
        },
        // { title: "Status", align: "left", sortable: true, value: "Status" },
        {
          title: "Created by",
          align: "left",
          sortable: true,
          value: "CreateBy",
        },
        {
          title: "Data Processed",
          align: "left",
          sortable: true,
          value: "ProcessingDate",
        },
        // { title: "Reprocess", align: "center", sortable: false },
        { title: "Manage", align: "center", sortable: false },
        { title: "Result", align: "left", sortable: false },
      ];
    },
  },
  watch: {
    "Validation.isGroup"(newVal) {
      if (newVal === true) {
        this.Validation.positive = null;
      }
    },
    // 'Validation.positive'(newVal){
    //   if (newVal === true){
    //     this.Validation.negative = !newVal
    //   }
    // },
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.Get();
    },
    getProcessStatusColor(item) {
      if (item.status === 'success') return "success";
      if (item.status === 'Processing' || item.status === 'Reprocess' || item.status === 'Processing score') return "warning";
      if (item.status === 'error' || item.status === 'error:score') return "error";
      return "grey";
    },

    getProcessStatusIcon(item) {
      if (item.status === 'success') return "mdi-check-circle-outline";
      if (item.status === 'Processing' || item.status === 'Reprocess' || item.status === 'Processing score') return "mdi-clock-outline";
      if (item.status === 'error' || item.status === 'error:score') return "mdi-alert-circle-outline";
      return "mdi-circle-outline";
    },
    PrepareCancel() {
      let self = this;

      self.$swal.fire({
        title: "Unsaved Changes",
        icon: "warning",
        html: "You haven't completed all required information. Are you sure you want to exit without saving?",
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("yes"),
        reverseButtons: true,
        focusCancel: true,
        buttonsStyling: false,
        allowOutsideClick: false,
        customClass: {
          popup: "swal-warning-popup",
          title: "swal-warning-title",
          htmlContainer: "swal-warning-body",
          actions: "swal-warning-actions",
          confirmButton: "swal-warning-confirm",
          cancelButton: "swal-warning-cancel",
          closeButton: "swal-warning-close",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked "Yes" - proceed to close and clear data
          self.closeUploaddialog();
        }

      });

    },
    closeUploaddialog() {
      let self = this;
      self.ProcessID = null;
      self.Uploaddialog = false;
      self.uploadedFiles = [];
      self.DeleteProcessPopUp = false;
      self.Validation.entity = null;
      self.Validation.validationName = null;
      self.Validation.modelId = null;
      self.Validation.positive = true;
      self.Validation.positiveFlag = null;
      self.Validation.generateId = null;
      self.Validation.PositiveName = null;
      self.Validation.negativeName = null;
      self.Validation.PositiveUploadFlag = null;
      self.Validation.isScore = true;
      self.Validation.isGroup = false;
    },
    clearRadio() {
      this.Validation.generateId = null;
      this.Validation.negativeName = null;
      this.Validation.isGroup = false;
    },
    ChainRadio() {
      this.Validation.positive = null;
      this.Validation.generateId = null;
      this.Validation.negativeName = null;
    },
    Get() {
      let self = this;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        name: self.searchName,
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            if (self.sortDesc == null) {
              self.AutoRefresh();
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDetail(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.$call.GetValidationProcessDetail(
        id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // self.Edit(dataResponse.data);
            let item = dataResponse.data;
            self.Validation.validationName = item.name;
            self.Validation.modelId = item.modelID == -1 ? null : item.modelID;
            self.Validation.isGroup = item.isGroup;
            self.Validation.positive = item.positiveFlag;
            self.Validation.positiveUploadFlag = item.positiveUploadFlag;
            self.Validation.negativeFlag = item.negativeFlag;
            self.Validation.generateId =
              item.positiveName != null ? item.positiveName : item.generateID;
            self.Validation.isScore = item.isScore;
            self.Validation.positiveName = item.positiveName;
            self.Validation.negativeName = item.negativeName;
            self.Validation.Prompt = item.prompt;
            self.dialog = false;
            self.Uploaddialog = true;
            self.loading = false;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      let self = this;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        name: self.searchName,
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          self.GetValidationGenerateDD();
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    GetValidationGenerateDD() {
      let self = this;
      self.loadingTable = true;
      self.$call.GetValidationGenerateDD(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGenerateQ = dataResponse.data;
          } else {
            self.DDGenerateQ = [];
          }
          self.GetValidationPositiveDD();
          self.GetValidationNegativeDD();
          self.loadingTable = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    GetValidationNegativeDD() {
      let self = this;
      self.dialog = true;
      self.$call.GetValidationNegativeDD(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationNegative = dataResponse.data;
          } else {
            self.DDValidationNegative = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetValidationPositiveDD() {
      let self = this;
      self.dialog = true;
      self.$call.GetValidationPositiveDD(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationPositive = dataResponse.data;
            self.DDGenerateQ = self.DDGenerateQ.concat(
              dataResponse.data
            ).filter(
              (element) =>
                element.questionType == "P" || element.questionType == null
            );
            self.chainQuestionList = self.DDValidationPositive.filter(
              (element, index, selfArray) =>
                element.questionType == "C" &&
                index ===
                selfArray.findIndex(
                  (e) => e.name.trim() === element.name.trim()
                )
            );
          } else {
            self.DDValidationPositive = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;

      if (self.processID == null) {
        self.SaveAdd();
      } else {
        self.SaveEdit(self.processID);
      }
    },
    SaveAdd() {
      let self = this;
      setTimeout(() => {
        self.validate();
      }, 100);
      if (
        self.Validation.validationName == null ||
        self.Validation.validationName == "" ||
        self.Validation.modelId == null ||
        self.Validation.modelId == "" ||
        (self.Validation.entity == null &&
          self.Validation.generateId == null &&
          self.Validation.negativeName == null &&
          self.Validation) ||
        (self.Validation.isScore == true &&
          (self.Validation.Prompt == null ||
            self.Validation.Prompt == "" ||
            self.Validation.Prompt == undefined))
        // || self.Validation.entity == null
      ) {
        // use self.$swal.fire to show an alert
        self.$swal.fire({
          title: "Incomplete Information",
          icon: "warning",
          html: "Please complete all required fields before saving. Some information is missing.",
          showCloseButton: true,
          focusConfirm: true,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.$t("ok"),
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            confirmButton: "swal-warning-confirm",
            closeButton: "swal-warning-close",
          },
        });
        return;
      }
      self.dialog = true;
      let request = {
        Name: self.Validation.validationName,
        ModelID: self.Validation.modelId,
        PositiveFlag:
          self.Validation.isGroup == true &&
            self.Validation.PositiveName == null
            ? false
            : self.Validation.positive,
        NegativeFlag:
          self.Validation.isGroup == true ? false : !self.Validation.positive,
        PositiveUploadFlag:
          self.Validation.isGroup == true ? false : self.Validation.positive,
        GenerateID:
          typeof self.Validation.generateId === "string"
            ? null
            : self.Validation.generateId,
        PositiveName:
          typeof self.Validation.generateId === "string"
            ? self.Validation.generateId
            : null,
        NegativeName: self.Validation.negativeName,
        IsScore: self.Validation.isScore,
        IsGroup: self.Validation.isGroup,
        Prompt: self.Validation.Prompt,
      };
      try {
        self.$call.CreateValidationProcess(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data != 0) {
                self.Processing(dataResponse.data);
              } else {
                self.$swal.fire({
                  title: "✔ Question Set Created Successfully !",
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    popup: 'success-banner',
                    title: 'success-banner-title'
                  },
                });
              }
              self.totalTable = self.totalTable + 1;
              self.Get();
              self.closeUploaddialog();
            } else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: true,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    SaveEdit(id) {
      let self = this;
      setTimeout(() => {
        self.validate();
      }, 100);
      if (
        self.Validation.validationName == null ||
        self.Validation.validationName == "" ||
        self.Validation.modelId == null ||
        self.Validation.modelId == "" ||
        (self.Validation.entity == null &&
          self.Validation.generateId == null &&
          self.Validation.negativeName == null &&
          self.Validation)
        // || self.Validation.entity == null
      ) {
        //alert("Please Fill All The Fields!");
        self.$swal.fire({
          title: "Incomplete Information",
          icon: "warning",
          html: "Please complete all required fields before saving. Some information is missing.",
          showCloseButton: true,
          focusConfirm: true,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.$t("ok"),
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            confirmButton: "swal-warning-confirm",
            closeButton: "swal-warning-close",
          },
        });
        return;
      }
      self.dialog = true;
      let request = {
        ProcessID: id,
        Name: self.Validation.validationName,
        ModelID: self.Validation.modelId,
        PositiveFlag:
          self.Validation.isGroup == true ? false : self.Validation.positive,
        NegativeFlag:
          self.Validation.isGroup == true ? false : !self.Validation.positive,
        PositiveUploadFlag:
          self.Validation.isGroup == true ? false : self.Validation.positive,
        GenerateID:
          typeof self.Validation.generateId === "string"
            ? null
            : self.Validation.generateId,
        PositiveName:
          typeof self.Validation.generateId === "string"
            ? self.Validation.generateId
            : null,
        NegativeName: self.Validation.negativeName,
        IsGroup: self.Validation.isGroup,
        IsScore: self.Validation.isScore,
        Prompt: self.Validation.Prompt,
      };
      try {
        self.$call.EditValidationProcess(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data != 0) {
                self.Processing(dataResponse.data);
              } else {
                self.$swal.fire({
                  title: "✔ Successfully Updated !",
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    popup: 'success-banner',
                    title: 'success-banner-title'
                  },
                });
              }
              self.Get();
              self.closeUploaddialog();
            } else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: true,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    GoToScore(id) {
      let self = this;
      self.$router.push({
        name: "DashboardScore",
        query: {
          id: id,
        },
      });
    },
    Processing(id) {
      let self = this;
      self.dialog = true;

      let request = {
        id: id,
        entity: self.Validation.entity,
      };

      try {
        self.$call.UploadValidationProcess(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.closeUploaddialog();
              self.Get();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    resourceResult(result) {
      if (result != "") {
        let arr = result.split("/");
        if (arr.length == 2) {
          return "0/" + arr[1];
        }
      }
      return result;
    },

    Reprocess(source) {
      let self = this;
      self.$swal
        .fire({
          title: self.$t("warning"),
          icon: "warning",
          html: this.$t("vectorReprocess"),
          showCloseButton: true,
          focusConfirm: true,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.$t("yes"),
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            confirmButton: "swal-warning-confirm",
            closeButton: "swal-warning-close",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            if (source.status != "error:score") {
              self.$call.ReprocessValidationProcess(
                source.processID,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    source.status = "Reprocess";
                    source.result = self.resourceResult(source.result);
                    self.$swal.fire({
                      title: "✔ Successfully Reprocessed !",
                      showConfirmButton: false,
                      timer: 1500,
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    self.AutoRefresh();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            } else self.ProcessingScore(source);
          }
        });
    },
    ProcessingScore(source) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      let temp = {
        ProcessID: source.processID,
        UserID: self.userId,
      };
      self.$call.ReGenerateValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit("filesUploaded", this.uploadedFiles);
      this.Validation.entity =
        this.uploadedFiles.length == 0 ? null : this.Validation.entity;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.Validation.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      // let temp = csv.replaceAll("\r", "");
      // let lines = temp.split("\n");
      // if (lines[0] != "Questions" && !this.Validation.isGroup) {
      //   this.Validation.entity = null;
      //   this.uploadedFiles = [];
      //   alert("Please Enter Correct Format!");
      // } else {
      //   const formDataDoc = new FormData();
      //   formDataDoc.append("entity", files[0]);
      //   this.uploadedFiles = files;
      //   this.Validation.entity = formDataDoc;
      // }

      const formFile = new FormData();
      formFile.append("formFile", files[0]); // key = "formFile" ตรงกับ parameter
      this.dialog = true;
      this.$call.ValidateCSV(
        formFile,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data) {
              this.$swal.fire({
                title: "✔ Successfully Uploaded !",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });

              const formDataDoc = new FormData();
              formDataDoc.append("entity", files[0]);
              this.uploadedFiles = files;
              this.Validation.entity = formDataDoc;
            } else {
              this.$swal.fire({
                // icon: "warning",
                // title: "Please Enter Correct Format!",
                // showConfirmButton: true,
                // backdrop: false
                title: "Unsupported file format !",
                html: "Please Enter Correct Format! or upload an .xlsx file no larger than 10 MB.",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: false,
                confirmButtonText: `<span class="swal-delete-btn-content">${this.$t("ok")}</span>`,
                reverseButtons: false,
                focusCancel: true,
                buttonsStyling: false,
                customClass: {
                  popup: "swal-delete-popup",
                  title: "swal-delete-title",
                  htmlContainer: "swal-delete-body",
                  actions: "swal-delete-actions",
                  confirmButton: "swal-delete-confirm",
                },
              });
              this.Validation.entity = null;
              this.uploadedFiles = [];
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: dataResponse.message,
              showConfirmButton: true,
            });
          }
          this.dialog = false;
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async downloadtemp() {
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทย",
        },
        {
          Questions: "จังหวัดที่อยู่ใต้สุดของประเทศไทย",
        },
        {
          Questions: "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย",
        },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 30 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "upload_questions.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    Download(id, fileName, isGroup) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.$call.DownloadCSVAnswer(
        { id, isGroup: false },
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            //let fileName = `Answers${self.convertDateToString(new Date(), '')}.csv`;
            // fileName += isGroup ? ".txt" : ".csv";
            if (!fileName.toLowerCase().endsWith('.csv')) {
              fileName += '.csv';
            }
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
          self.loading = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    async chainTemplate() {
      const data = [
        ["Questions"],
        ["สวัสดีครับ"],
        ["Reset password ยังไง"],
        ["ระบบ AMACS"],
        ["#End#"],
        ["สวัสดีครับ"],
        ["ขอ NetworkID"],
        ["ระบบ UMS"],
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 50 },
        { header: "Human Answer", key: "Human Answer", width: 70 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Chain_template.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;

      do {
        for (let value of self.dataTable) {
          let totalSp = value.result.split("/");
          let total = parseInt(totalSp[0]);
          let total2 = parseInt(totalSp[1]);
          if (
            total < total2 &&
            (value.status == "Reprocess" ||
              value.status == "Processing" ||
              value.status == "Processing score")
          ) {
            self.ReFreshGet();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != "/ValidationProcess") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    showPopup(id) {
      let self = this;
      self.processID = null;
      if (id != null) {
        self.processID = id;
        self.QuestionType = false;
        self.GetDetail(id);
      } else {
        self.QuestionType = true;
        self.Uploaddialog = true;
        self.Validation.validationName = null;
        self.Validation.modelId = null;
        self.Validation.Prompt = `You are an evaluator that scores the relevance of a chatbot's response based on the provided input.

If only the "Question" and "Bot's Response" are given, evaluate based solely on these two.
If a "Human's Response" is also provided, use it as an additional reference for scoring.
Scoring criteria:

0: Not related at all
1: Somewhat related
2: Very related
Evaluate the following input and respond only with a single number (0, 1, or 2). Do not include any explanation or additional text.

Provided data:

Question: {Question}
Bot's Response: {Bot’s Response}
Human's Response (if available): {Human’s Response}
Your response must be only a single number (0, 1, or 2).`;
      }
    },
    //   async DeleteProcessPopup(id) {
    //     try {
    //       const result = await this.$swal.fire({
    //         title: this.$t('confirmDeletion'),
    //         text: "Do you want to confirm deletion of this validation",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: this.$t('confirm'),
    //         cancelButtonText: this.$t('cancel'),
    //         reverseButtons: false,
    //       });

    //       if (result.isConfirmed) {
    //         this.dialog = true;
    //         this.$call.DeleteValidationProcess(
    //           id,
    //           (dataResponse) => {
    //             this.dialog = false; // Ensure this.dialog is set to false after the operation
    //             if (dataResponse.status === 0) {
    //               this.Get(); // Refresh the data if the deletion was successful
    //               this.$swal.fire({
    //                 icon: 'success',
    //                 title: dataResponse.message,
    //                 showConfirmButton: false,
    //                 timer: 1500,
    //               });
    //             } else if (dataResponse.status === 4) {
    //               this.$swal.fire({
    //                 icon: 'warning',
    //                 title: this.$t('oneSuperAdmin'),
    //                 showConfirmButton: false,
    //                 timer: 2000,
    //               });
    //             } else {
    //               // Handle unexpected statuses
    //               this.$swal.fire({
    //                 icon: 'error',
    //                 title: 'Error',
    //                 text: dataResponse.message || 'An unexpected error occurred',
    //                 showConfirmButton: true,
    //               });
    //             }
    //           },
    //           (errorResource) => {
    //             this.dialog = false;
    //             console.error(errorResource);
    //             this.$swal.fire({
    //               icon: 'error',
    //               title: 'Error',
    //               text: 'An error occurred while processing your request.',
    //               showConfirmButton: true,
    //             });
    //           }
    //         );
    //       }
    //     } catch (error) {
    //       this.LogTrace(error, 'DeleteUser');
    //       this.$swal.fire({
    //         icon: 'error',
    //         title: 'Error',
    //         text: 'An unexpected error occurred.',
    //         showConfirmButton: true,
    //       });
    //     }
    // }
    DeleteProcessPopup(Id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            html: "Do you want to confirm deletion of this validation? This action cannot be undone.",
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonText: this.$t("cancel"),
            confirmButtonText: `<span class="swal-delete-btn-content"><img src="${deleteIcon}" alt="" class="swal-delete-btn-icon" />${this.$t("delete")}</span>`,
            reverseButtons: false,
            focusCancel: true,
            buttonsStyling: false,
            customClass: {
              popup: "swal-delete-popup",
              title: "swal-delete-title",
              htmlContainer: "swal-delete-body",
              actions: "swal-delete-actions",
              confirmButton: "swal-delete-confirm",
              cancelButton: "swal-delete-cancel",
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationProcess(
                Id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      title: "✔ Successfully Saved !",
                      showConfirmButton: false,
                      timer: 1500,
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                  }
                  self.dialog = false;
                  self.Get();
                },
                (errorResource) => {
                  self.dialog = false;
                  self.isSearch = false;
                  self.$swal.fire({
                    title: self.$t("Error"),
                    text: "Something went wrong",
                    icon: "warning",
                  });
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        self.LogTrace(error, "DeleteGroup");
      }
    },

    showWarningAlert(title, messageHtml) {
      const rawOkLabel = this.$t ? this.$t("ok") : "OK";
      const confirmLabel = rawOkLabel && rawOkLabel.toString().trim().length > 0
        ? rawOkLabel
        : "OK";

      return this.$swal.fire({
        title,
        html: messageHtml,
        icon: "warning",
        showCloseButton: true,
        focusConfirm: true,
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: confirmLabel,
        customClass: {
          popup: "swal-warning-popup",
          title: "swal-warning-title",
          htmlContainer: "swal-warning-body",
          actions: "swal-warning-actions",
          confirmButton: "swal-warning-confirm",
          closeButton: "swal-warning-close",
        },
      });
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    self.GetDDGPTModel();
  },
};
</script>
<style scoped>
textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}

.modern-dialog {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-text {
  flex: 1;
}
*/
/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */
/*
.close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

/* Dialog Content */
.dialog-content {
  padding: 20px 24px !important;
  background: #ffffff;
  max-height: 70vh;
  overflow-y: auto;
}

.field-container {
  margin-bottom: 0px;
}

.field-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: block;
  letter-spacing: 0.25px;
}

/* Modern field and textarea shared styles */
.modern-field :deep(.v-field__outline),
.modern-textarea :deep(.v-field__outline) {
  border-radius: 12px !important;
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline),
.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field :deep(.v-field),
.modern-textarea :deep(.v-field) {
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-field:hover :deep(.v-field__outline),
.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-label),
.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-field :deep(.v-field--focused .v-label),
.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-field :deep(.v-field__input),
.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-field :deep(.v-field__input::placeholder),
.modern-textarea :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Radio Group Styles */
.modern-radio-group {
  margin-top: 8px !important;
}

.radio-container {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.modern-radio :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 4px 0;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-radio :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-radio :deep(.v-selection-control--dirty) {
  border-color: currentColor;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.radio-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* Checkbox Styles */
.modern-checkbox :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-checkbox :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-checkbox :deep(.v-selection-control--dirty) {
  border-color: rgba(25, 118, 210, 0.3);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.checkbox-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* Files Display */
.files-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: all 0.2s ease;
}

.files-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08);
}

.files-card .v-card-title {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.file-item {
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item .v-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Template Download Button */
.template-download-btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.template-download-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.3) !important;
}

/* Dialog Actions */
.dialog-actions {
  background: rgba(248, 249, 250, 0.5) !important;
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
}

/* Upload File Component Integration */
.UploadFile {
  width: 100%;
}

.score-btn {
  border-radius: 50% !important;
  width: 45px !important;
  height: 45px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: linear-gradient(135deg, #3859D0 0%, #BD6AD5 127.43%) !important;
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.3) !important;
}

.score-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05) !important;
  box-shadow: 0 8px 20px rgba(156, 39, 176, 0.4) !important;
  background: linear-gradient(135deg, #ab47bc 0%, #7e57c2 100%) !important;
}

.score-btn:active:not(:disabled) {
  transform: translateY(0) scale(1) !important;
}

.score-btn:disabled {
  background: #e0e0e0 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  cursor: not-allowed !important;
  transform: none !important;
  opacity: 0.6 !important;
}

.score-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.score-btn:hover:not(:disabled) .v-icon {
  transform: scale(1.1) rotate(5deg) !important;
}

/* Pulse animation for active state */
.score-btn:not(:disabled) {
  position: relative;
}

.score-btn:not(:disabled)::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(156, 39, 176, 0.3);
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease;
}

.score-btn:hover:not(:disabled)::before {
  transform: translate(-50%, -50%) scale(1.3);
  opacity: 0;
}

/* Shimmer effect for successful state */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

.score-btn:not(:disabled) {
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
}

/* Enhanced tooltip styling */
.score-btn .v-tooltip {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

/* =============================================================================
   RESPONSIVE DESIGN FOR SCORE BUTTON
   ============================================================================= */
@media (max-width: 768px) {
  .score-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .score-btn .v-icon {
    font-size: 20px !important;
  }
}

/* =============================================================================
   ACTION BUTTONS GROUP ENHANCEMENT
   ============================================================================= */
.action-buttons-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.action-btn {
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
}

.action-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.edit-btn:hover {
  background-color: rgba(var(--v-theme-primary), 0.1) !important;
}

.reprocess-btn:hover {
  background-color: rgba(var(--v-theme-info), 0.1) !important;
}

.download-btn:hover:not(:disabled) {
  background-color: rgba(var(--v-theme-success), 0.1) !important;
}

.download-btn:disabled {
  background-color: rgba(0, 160, 35, 0.295) !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.delete-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Rotating animation for reprocess icon */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotate 1s linear infinite;
}

/* Hover effects for icons */
.action-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.action-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Disabled state styling */
.action-btn:disabled {
  cursor: not-allowed !important;
}

.action-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Action divider */
.action-divider {
  width: 1px;
  height: 24px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
}

:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
  width: 100% !important;
  border-radius: 10px !important;
  font-weight: 500 !important;
}

/* Animations */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .dialog-header {
    padding: 20px 16px !important;
  }

  .dialog-title {
    font-size: 1.25rem !important;
  }

  .dialog-content {
    padding: 24px 16px !important;
  }

  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }

  .radio-container {
    flex-direction: column;
    gap: 8px;
  }
}

.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 200px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}


/* action disable button delete */
.delete-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  background-color: rgba(236, 15, 15, 0.304) !important;
  pointer-events: none !important;
}

.delete-btn:disabled .v-icon {
  color: rgb(253, 19, 3) !important;
}

.delete-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: rgba(244, 67, 54, 0.1) !important;
}

.edit-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  background-color: rgba(245, 193, 37, 0.686) !important;
  pointer-events: none !important;
}

.edit-btn:disabled .v-icon {
  color: rgb(155, 122, 31) !important;
}
</style>

<!-- Redesign batch css -->
<style scoped>
.main-page-div {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.redesign-main-page-container {
  padding: 24px;
}

.main-content-card {
  border-radius: 16px !important;
  border: 1px solid #DCDCDC !important;
  background: #FFF !important;
  overflow: hidden;
  padding: 20px;
}

.reportdata-icon-btn {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  min-width: 42px;
  transform: scaleX(-1);
}

.reportdata-icon-btn--ghost {
  background: #ffffff !important;
  color: #171717 !important;
  border: 1px solid #d0d0d0 !important;
}

/* table base */
:deep(thead) {
  background-color: #FFF2F2 !important;
  padding: 0 8px;
}

.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

/* table */

.manage-image-icon {
  width: 25px;
  height: 25px;
}

.chip-processing {
  border-radius: 100px;
  border: 2px dashed var(--Royal-blue, #001763);
  background: #EABD07 !important;
  color: #ffffff !important;
}

.chip-label {
  color: inherit;
}

.image-icon-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

/* New Dialog Redesign Styles */
.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.info-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}

/* Modern Field Styles - Matching DashboardScore */
.modern-field {
  margin-top: 0px;
}

.modern-field :deep(.v-field) {
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: unset !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline) {
  border-color: #e0e0e0 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field:hover :deep(.v-field__outline) {
  border-color: #e0e0e0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 5px 10px !important;
}

.modern-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Modern Textarea */
.modern-textarea {
  margin-top: 0px;
}

.modern-textarea :deep(.v-field) {
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #e0e0e0 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-textarea:hover :deep(.v-field__outline) {
  border-color: #e0e0e0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

/* Custom Radio Group Styles */
.custom-radio-group {
  margin-top: 0 !important;
}

.custom-radio-group :deep(.v-selection-control) {
  min-height: auto !important;
  margin-right: 24px;
}

.custom-radio {
  margin-right: 24px;
}

.custom-radio :deep(.v-selection-control__wrapper) {
  height: 20px;
}

.custom-radio :deep(.v-selection-control__input) {
  width: 20px;
  height: 20px;
}

/* CRITICAL: Remove ALL default Vuetify backgrounds */
.custom-radio :deep(.v-selection-control__input::before),
.custom-radio :deep(.v-selection-control__input::after) {
  content: none !important;
  display: none !important;
  background: none !important;
  background-color: transparent !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.custom-radio :deep(.v-selection-control__input .v-icon) {
  font-size: 20px !important;
  color: #C32E0E !important;
}

/* Unchecked state - Red circle outline */
.custom-radio :deep(.v-selection-control__input .mdi-radiobox-blank) {
  color: #C32E0E !important;
  opacity: 0.6 !important;
}

/* Checked state - Red filled circle */
.custom-radio :deep(.v-selection-control--dirty .v-selection-control__input .mdi-radiobox-marked) {
  color: #C32E0E !important;
  opacity: 1 !important;
}

/* Force override any inherited color */
.custom-radio :deep(.v-selection-control--dirty .v-selection-control__input) {
  color: #C32E0E !important;
}

.custom-radio :deep(.v-label) {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  color: #495057 !important;
  opacity: 1 !important;
}

/* Upload Card */
.upload-card {
  border-radius: 16px;
  border: 2px dashed #949AA8 !important;
  background: linear-gradient(90deg, #FFF2F2 -15.8%, #FFF 100%) !important;
  transition: all 0.3s ease;
  min-height: 120px;
}

.upload-card:hover {
  border-color: #949AA8 !important;
  background: #FFF2F0 !important;
}

/* Border Section Wrapper for Checkbox */
.border-section-wrapper {
  border-radius: 24px;
  padding: 15px 10px;
  border: 1px solid #a0a0a0;
  transition: all 0.3s ease;
  width: 100% !important;
}

.checkbox-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* Template Button */
.template-btn {
  min-height: 35px !important;
  border-radius: 12px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
  border-color: #C32E0E !important;
  color: #C32E0E !important;
}

.template-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(195, 46, 14, 0.3) !important;
  background: rgba(195, 46, 14, 0.04) !important;
}
/* Modern Autocomplete/Select Dropdown Arrow - Red Color */
.modern-field :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}

.modern-field :deep(.v-autocomplete__menu-icon) {
  color: #872612 !important;
}
</style>